export default {
    namespaced: true,
    state: {
        banners: []
    },
    mutations: {
        SET_BANNERS(state, banners) {
            state.banners = banners
        }
    },
    actions: {
        async get({ commit }) {
            const url = '/public/catalog/main-page-banners'

            try {
                const resp = await this.$axios.get(url)
                commit('SET_BANNERS', resp.data.main_page_banners)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                }
            }
        },
    }
}
